
import Footer from "./StudentFooter";
import HeaderPath from "./Studentheader";
const Layout = ({ children }) => {
  return (
    <>
     <div id="main-wrapper">
   
      <HeaderPath />
      {children}
      <Footer />
    </div>
    </>
  );
};

export default Layout;
